import { colors } from '../colors';

export const tooltip = {
  fontSize: '13px',
  color: colors.gray[900],
  backgroundColor: colors.yellow[600],
};
